function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}






// Get the close icon element
// const closeIcon = document.querySelector('.close__icon');

// // Get the details element
// const detailsElements = document.getElementById('Details-menu-drawer-container');

// // Add a click event listener to the close icon
// closeIcon.addEventListener('click', () => {
//   // Remove the "open" attribute from the details element
//   detailsElements.removeAttribute('open');
// });





document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (deferredElement && deferredElement.tagName === 'VIDEO') {
          deferredElement.play(); 
       }
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    console.log(this.querySelector('.product-form__buttons .addons-submit-button'))

    this.querySelector('.product-form__buttons .addons-submit-button').addEventListener('click', (event) => {
      event.preventDefault();
      console.log('d;lsfdsjflks')
      let checkboxElement = document.querySelectorAll("slideshow-component [type='checkbox']");
      let items = []
      checkboxElement.forEach((each) => {
        if (each.checked) {
          let parentElement = each.closest('pair-products');
          let data = {
            id: parentElement.querySelector('.main_product_price_id').value,
            qunatity: 1
          }
          items.push(data)
        }
      });
      console.log(items)

    })
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();


    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      
    }

  }


  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  sortImageIn(container){
    // Ordering the element to appear in order of the arrangement on the admin PDP page.
    // Arrange the image according to order you require to appear
    let items = Array.from(container.querySelectorAll('.carousel-cell'));

    items.sort(function(a, b) {
        var imgA = a.querySelector('img');
        var imgB = b.querySelector('img');
        var indexA = imgA ? parseInt(imgA.getAttribute('data-index'), 10) : 0;
        var indexB = imgB ? parseInt(imgB.getAttribute('data-index'), 10) : 0;
        return indexA - indexB;
    });

    container.innerHTML = '';
    
    items.forEach(function(item) {
        container.appendChild(item);
    });
  }

  
  updateMedia() {
    const buybtnDiv = document.querySelector('.price_change');
    const mainPriceProduct = document.querySelector('.price-item--last');
    const PriceChange = mainPriceProduct?.getAttribute('data-main-product-price');


    if (buybtnDiv) {
      buybtnDiv.innerText = PriceChange;
      buybtnDiv.style.zIndex = '99999';
    }

    const VariantNameSizes = document.querySelector(".fieldset-1 .variant_name_sizes")
    const VariantNameCheckbox = document.querySelector('.fieldset-1 .artical_number_id:checked')
    const VariantNameDataAttribute = VariantNameCheckbox?.getAttribute('variant-name')
    if(VariantNameSizes){
      VariantNameSizes.innerHTML = VariantNameDataAttribute
    }
  
    const VariantNameSizestwo = document.querySelector(".fieldset-2 .variant_name_sizes")
    const VariantNameCheckboxtwo = document.querySelector('.fieldset-2 .artical_number_id:checked')
    const VariantNameDataAttributetwo = VariantNameCheckboxtwo?.getAttribute('variant-name')
    if(VariantNameSizestwo){
      VariantNameSizestwo.innerHTML = VariantNameDataAttributetwo
    }
    
    const ProductArticleNumberEle = document.querySelector('.product_artical_number')
    const checkedVariant = document.querySelector('.artical_number_id:checked')
    const productArticleNumber = checkedVariant?.getAttribute('data-artical-number') 
    if (ProductArticleNumberEle) {
      ProductArticleNumberEle.innerHTML = productArticleNumber
    }
    if (!this.currentVariant) return;
    let variantName;
    let checkedColorVariant = document.querySelector(".color_swatch_div.product-form__input input[type=radio]:checked") ;

    if (checkedColorVariant) {
      variantName = checkedColorVariant.getAttribute("data-variant-handleize-name");
    }

    if (customElements.get("product-gallery")) {
      const productGallery = document.getElementById(
        `ProductGallery-${this.dataset.section}`
      );
      productGallery?.setActiveMedia(variantName, true );
    } else {
      if (!this.currentVariant.featured_media) return;

      const mediaGalleries = document.querySelectorAll(
        `[id^="MediaGallery-${this.dataset.section}"]`
      );
      mediaGalleries.forEach((mediaGallery) =>
        mediaGallery?.setActiveMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
          true, variantName
        )
      );

      const modalContent = document.querySelector(
        `#ProductModal-${this.dataset.section} .product-media-modal__content`
      );
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      modalContent.prepend(newMediaModal);
    }
  }
  
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }


  
  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const VariantPriceOnButton = document.querySelector('.update--price__button');
        const variantPriceSoure = html.querySelector('.update--price__button');
        const variantPriceDestinationEl = document.querySelector(".add_to_cart_btn")
        const variantPriceSourceEl = html.querySelector(".add_to_cart_btn");
        const destinationStickyAddtoCart = document.querySelector(".sticky-add-to-cart-button");
        const sourceStickyAddtoCart = html.querySelector(".sticky-add-to-cart-button");
        const sizeVariantDropdownListDestination =  document.querySelectorAll(".product-size-variant-list .variant-price");
        const sizeVariantDropdownListSource =  html.querySelectorAll(".product-size-variant-list .variant-price");
         if (destinationStickyAddtoCart &&  sourceStickyAddtoCart){
            destinationStickyAddtoCart.innerHTML = sourceStickyAddtoCart.innerHTML
         }
        const inventoryStatus = document.querySelector('.inventory-quantity-status');
        const sourceInventoryStatus = html.querySelector(".inventory-quantity-status");
        if (inventoryStatus &&  sourceInventoryStatus){
          inventoryStatus.innerHTML = sourceInventoryStatus.innerHTML
        }
        if (sizeVariantDropdownListDestination?.length > 0 && sizeVariantDropdownListSource?.length > 0 ){
          sizeVariantDropdownListDestination.forEach((element, index) => {
            element.innerHTML = sizeVariantDropdownListSource[index].innerHTML;
          })
        }
        if (source && destination) destination.innerHTML = source.innerHTML;
        if(VariantPriceOnButton && variantPriceSoure )  VariantPriceOnButton.innerHTML = variantPriceSoure.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }
        if (variantPriceSourceEl && variantPriceDestinationEl){
          variantPriceDestinationEl.innerHTML = variantPriceSourceEl.innerHTML
            
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant
          }
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent =  text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    
    
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);



// on hover display megamenu //
document.querySelectorAll(".mega-menu").forEach((element) => {
  element.addEventListener("mousemove", function (event) {
    document.querySelectorAll(".mega-menu").forEach((element) => {
      element.removeAttribute("open");
    });
    let currentElement = event.target;
    let details = currentElement.closest(".mega-menu");
    details.setAttribute("open", " ");
  });
});

/* ----------- megamenu start --------- */
document.querySelectorAll(".mega-menu").forEach((element) => {
  element.addEventListener("mouseout", function (event) {
    document.querySelectorAll(".mega-menu").forEach((element) => {
      element.removeAttribute("open");
    });
  });
});

document.querySelectorAll(".mega-menu__content").forEach((element) => {
  element.addEventListener("mousemove", function (event) {
    // console.log(event.srcElement);
    const currentElement = event.target;
    const details = currentElement.closest(".mega-menu");
    details.setAttribute("open");
  });
});

document.querySelectorAll(".mega-menu__content").forEach((element) => {
  element.addEventListener("mouseout", function (event) {
    // console.log(event.srcElement);
    const currentElement = event.target;
    const details = currentElement.closest(".mega-menu");
    details.removeAttribute("open");
  });
});

document.addEventListener("DOMContentLoaded", onPageLoad);

//onpage load the will disable linklist child element
function onPageLoad() {
  document.querySelectorAll('.parent-link').forEach((each) => {
    const ulElement = each.querySelector('ul');
    if (ulElement) {
      ulElement.style.display = 'none';
    }
    else if (each.querySelector('.dropdown-icon')) {
      each.querySelector('.dropdown-icon').style.display = 'none';
    }
  });
}






//on click of drop icon it will disable other other parent link element and show the links of clicked element
const parentElements = Array.from(document.querySelectorAll('.parent-link'));
document.querySelectorAll('.dropdown-icon').forEach((each) => {
  each.addEventListener('click', (event) => {
    parentElements.forEach((element) => {
      element.style.display = 'none';
      element.classList.remove('active-parent');
      const ulElement = element.querySelector('ul');
      if (ulElement) ulElement.style.display = 'none';
    });
    each.closest('.parent-link').style.display = 'block';
    each.closest('.parent-link').classList.add('active-parent');
    const ulElement = each.closest('.parent-link').querySelector('ul');
    document.querySelector('.backarrow-container').style.display = 'inline-block'
    if (ulElement) ulElement.style.display = 'block';
  });
});

// onclick close and back icon the the function initlize and reset all the parent menu 
function resetLinks() {
  document.querySelectorAll('.parent-link').forEach((each) => {
    each.style.display = 'block';
    each.classList.remove('active-parent');
    const ulElement = each.querySelector('ul');
    if (ulElement) ulElement.style.display = 'none';
  });
  document.querySelector('.backarrow-container').style.display = 'none';
}

document.querySelectorAll('.backarrow-container').forEach((each) => each.addEventListener('click', resetLinks));
document.querySelector('.close__icon').addEventListener('click', resetLinks);

//mobile-menu link redirection
const anchorElements = document.querySelectorAll('.parent-link-title');

Array.from(anchorElements).forEach((each) => {
  each.addEventListener('click', (event) => {
    event.preventDefault();
    window.location.href = each.getAttribute('href');
  });
});



////// cart page variants in cart drawer
//to add checked attribute for variants

var variantDiv = document.querySelectorAll(".product_variant_sizes.mobile_product_varints");

variantDiv.forEach(item => {
  item.style.display = "none"
})



function openVariants() {
  var hiddenDiv = event.target.nextElementSibling; // Assuming the hidden div is the next sibling
  hiddenDiv.style.display = "block";
}

function openVariants(clickedDiv) {
  var hiddenDiv = clickedDiv.nextElementSibling;
  var computedStyle = window.getComputedStyle(hiddenDiv);

  if (computedStyle.display === "block" || computedStyle.display === "inline-block") {
    hiddenDiv.style.display = "none";
  } else {
    hiddenDiv.style.display = "block";
  }
}

// Function to find the first available variant
function findFirstAvailableVariant(container) {
  const labels = container.querySelectorAll('.custom-label');
  for (let i = 0; i < labels.length; i++) {
    const label = labels[i];
    if (!label.classList.contains('unavailable')) {
      return label.textContent;
    }
  }
  return ''; // Return an empty string if no available variants are found
}

// Function to set up variant selection
function setupVariantSelection(container) {
  const labels = container.querySelectorAll('.custom-label');
  const variantNameDiv = container.querySelector('.varinat_name_mbl');
  const variantSizesDiv = container.querySelector('.product_variant_sizes.mobile_product_varints');

  // Update the selected variant name initially
  const initialVariantName = findFirstAvailableVariant(container);
  variantNameDiv.textContent = initialVariantName;

  labels.forEach(label => {
    label.addEventListener('click', () => {
      const selectedText = label.textContent;
      variantNameDiv.textContent = selectedText;

      // Hide the variant sizes div
      variantSizesDiv.style.display = 'none';
    });
  });
}


// Call the setupVariantSelection function for each variant section
const variantContainers = document.querySelectorAll('.mobile-variants-select');
variantContainers.forEach(container => {
  setupVariantSelection(container);
});

// Call the function for each set of elements
const containers = document.querySelectorAll('.main_container_loop_variants');
containers.forEach(container => {
  setupVariantSelection(container);
});


/*=============================================variant prices in product cartdrawer========================  */
class DetailsSummary extends HTMLElement {
  constructor() {
    super();

    // write element functionality in here
    ///cart note items js

    const checkbox = document.querySelector('.checkbox_for_cart_note');
    const details = document.getElementById('Details-CartDrawer');
    const wordcountSaveBtn = document.getElementById('wordcount_save_btn');
    const textarea = document.getElementById('CartDrawer-Note');
    const cartDrawerNoteLabel = document.querySelector('.cart_drawer_note');

    // Function to toggle the visibility of the wordcount_save_btn
    const toggleWordcountSaveBtn = () => {
      if (details.open) {
        wordcountSaveBtn.style.display = 'block';
      } else {
        wordcountSaveBtn.style.display = 'none';
      }
    };

    // Function to handle the visibility of the cart note label
    const handleCartNoteLabelVisibility = () => {
      if(textarea && cartDrawerNoteLabel){
        const textareaValue = textarea.value.trim();
        if (textareaValue.length > 0) {
          cartDrawerNoteLabel.style.display = 'none';
        } else {
          cartDrawerNoteLabel.style.display = '';
        }
      }
    };

    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        details.setAttribute('open', true);
      } else {
        details.removeAttribute('open');
      }
      toggleWordcountSaveBtn();
      handleCartNoteLabelVisibility();
    });

    // Add event listener for the details element's toggle event
    details.addEventListener('toggle', toggleWordcountSaveBtn);

    // Showing the count
    const wordCountElement = document.getElementById('wordCount');

    textarea.addEventListener('input', () => {
      const inputText = textarea.value;
      const words = inputText.trim().split(/\s+/);
      const wordCount = words.length;
      wordCountElement.textContent = `${wordCount}/250`;

      handleCartNoteLabelVisibility();
    });

    // Hiding the cart note label
    if (cartDrawerNoteLabel) {
      cartDrawerNoteLabel.addEventListener('click', () => {
        cartDrawerNoteLabel.style.display = 'none';
      });
    }

    // Initially handle the visibility of the cart note label
    handleCartNoteLabelVisibility();

    // Initially toggle the wordcount_save_btn based on the initial state of the details element
    toggleWordcountSaveBtn();
  }
}

customElements.define("details-summary", DetailsSummary);

//////////////////////////////////////////////////////////////////////////////////////


class DynamicProductCards extends HTMLElement {
  constructor() {
    super();

    this.variantDataScript = this.querySelector('[type="application/json"]');

    if (this.variantDataScript) {
      this.variantData = JSON.parse(this.variantDataScript.textContent);
      this.addEventListener("input", this.onVariantChange.bind(this));
    }
  }
  onOptionClick(event) {
    const target = event.target;
    if (target && target.type === "radio") {
      this.onVariantChange();
    }
  }

  onVariantChange() {

    let selectedOptions = [];
    this.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (input.checked) {
        selectedOptions.push(input.value);
      }
    });

    this.getCurrentVariant(selectedOptions);
  }

  getCurrentVariant(options) {
    let currentVariant = {};

    this.variantData.forEach(function (variant) {
      if (JSON.stringify(variant.options) == JSON.stringify(options)) {
        currentVariant = variant;
      }
    });

    this.updateMainId(currentVariant);
  }

  updateMainId(currentVariant) {
    this.querySelector('[name="id"]').value = currentVariant.id;

    this.getUpdatedCard(currentVariant);
  }

  getUpdatedCard(currentVariant) {
    this.sectionId = this.dataset.sectionId;
    this.productHandle = this.dataset.productHandle;

    // Include the variant ID in the request URL
    const requestUrl = `${this.productHandle}?variant=${currentVariant.id}&section_id=${this.sectionId}`;

    fetch(requestUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
 
        const html = new DOMParser().parseFromString(responseText, "text/html");

        // Find the target element in the updated content
        const targetElement = html.querySelector(
          `[data-product-handle="${this.productHandle}"]`
        );

        if (targetElement) {
        
          // Update the innerHTML if the target element exists
          this.innerHTML = targetElement.innerHTML;
          // !
  
      
          this.querySelectorAll('.product-card__option').forEach(option => {

            option.addEventListener('click', () => {
             
              // Find the child element with class '.product-card__option--values'
              const valuesElement = option.querySelector('.product-card__option--values');
              if (valuesElement) {
             
                // Toggle the visibility by adding/removing the 'd-none' class
                valuesElement.classList.toggle('d-none');
              } 
            });
          });
          // Attach a click event handler to the "Add to Bag" button
          const addToBagButton = this.querySelector('.add-to-bag-button');
          if (addToBagButton) {
            addToBagButton.addEventListener('click', () => {
              // Add the selected variant to the cart
              this.addToCart(currentVariant);
            });
          }
        } else {
          console.error(`Target element not found for product handle ${this.productHandle}`);
        }
      })
      .catch((error) => {
        console.error("Error fetching or processing product details:", error);
      });
  }




}

customElements.define("dynamic-product-cards", DynamicProductCards);



////////////////////////////////variant name selected/////////////////////////////////


// Get all radio inputs within the product options
const radioInputs = document.querySelectorAll('.product-card__option--value input[type="radio"]');

// Add event listeners to all radio inputs
radioInputs.forEach(input => {
  input.addEventListener('change', () => {
    updateSelectedVariantName(input);
  });
});

function updateSelectedVariantName(selectedInput) {
  const optionName = selectedInput.name;
  const selectedValue = selectedInput.value;
  const optionContainer = selectedInput.closest('.product-card__option');
  const selectedVariantNameElement = optionContainer.querySelector('.selected_variant_name');
  selectedVariantNameElement.textContent = selectedValue;
}

// pair-products.js

class PairProducts extends HTMLElement {
  constructor() {
    super();

    /////// pair products names update starts//////////////////




// Add a click event listener to each radio button within each product card
const productCards = document.querySelectorAll('.product-card');
console.log(productCards)
productCards.forEach((productCard) => {
  productCard.addEventListener('change', function (event) {
    if (event.target.classList.contains('variant-radio')) {
      const selectedValue = event.target.value;
      const selectedVariantNameElement = productCard.querySelector('.selected_variant_name');
      
      event.target.closest('.product-card__option').querySelector('.selected_variant_name').textContent = selectedValue;
    }
  });
});

    
// /////////////////////////// pair products name will update here/////////////////

    this.selectedVariantIds = [];
    // Attach a change event listener to checkboxes
    let checkboxes = this.querySelectorAll('.variant-checkbox');
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', (event) => {
        this.handleCheckboxChange(event.target);
      });
    });

    this.variantDataScript = this.querySelector('[type="application/json"]');

    if (this.variantDataScript) {
      this.variantData = JSON.parse(this.variantDataScript.textContent);
      this.addEventListener("input", this.onVariantChange.bind(this));
    }

    /// updating the variants close and open toggle

    let main_container_divs = this.querySelectorAll(".product-card__option--values");
    let toggle_containers = this.querySelectorAll(".product-card__option--name.dynamic_variant_names_container");

    // Set the initial display property to "none"
    main_container_divs.forEach((div) => {
      div.style.display = "none";
    });


    // Add a click event listener to each toggle_container
    toggle_containers.forEach((toggle_container, index) => {
      toggle_container.addEventListener("click", () => {
        // Toggle the display property of the corresponding main_container_div
        if (main_container_divs[index].style.display === "none" || main_container_divs[index].style.display === "") {
          main_container_divs[index].style.display = "block";
        } else {
          main_container_divs[index].style.display = "none";
        }
      });
    });

    // Call a method to calculate and print the total price
    this.calculateTotalPrice();
  }

  handleCheckboxChange(checkbox) {
    let variantId = checkbox.closest('.product-card').querySelector('.main_product_price_id').value;
    let isChecked = checkbox.checked;

    if (isChecked) {
      // Add the currently selected variant ID to the array if not already present
      if (!this.selectedVariantIds.includes(variantId)) {
        this.selectedVariantIds.push(variantId);
      }
    } else {
      // Remove the variant ID from the array if it's present
      let index = this.selectedVariantIds.indexOf(variantId);
      if (index !== -1) {
        this.selectedVariantIds.splice(index, 1);
      }
    }
    // Print the selected variant IDs to the console
    console.log('Selected Variant IDs:', this.selectedVariantIds);
  }

 
  /* variants total count*/

   calculateTotalPrice() {
    // Get all elements with class "dynamic_product_price_total_cart_prices"
    let priceElements = document.querySelectorAll('.dynamic_product_price_total_cart_prices');
    let pairs_Price = 0;
  
    // Calculate the total price
    priceElements.forEach((element) => {
      let priceText = element.dataset.pairPrice;
      let parsePrice = parseInt(priceText);
      if (!isNaN(parsePrice)) {
        pairs_Price += parsePrice;
      }
    });
  
    // Find the element with class "total_price_pair_products" and update its text content
    let totalPriceElement = document.querySelector('.total_price_pair_products');
    if (totalPriceElement) {
      totalPriceElement.textContent = "$" + pairs_Price;
    }
  
    // Find the element with class "pair-products" and update its data attribute
    let pairProductsElement = document.querySelector('.pair-products');
    if (pairProductsElement) {
      pairProductsElement.setAttribute('data-pairs-price', pairs_Price.toString());
    }
  }
  

  /* variants total count*/
  onOptionClick(event) {
    const target = event.target;
    if (target && target.type === "radio") {
      this.onVariantChange();
    }
  }


  onVariantChange() {
    let selectedOptions = [];
    this.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (input.checked) {
        selectedOptions.push(input.value);
      }
    });

    this.getCurrentVariant(selectedOptions);
  }


  getCurrentVariant(options) {
    let currentVariant = {};

    this.variantData.forEach(function (variant) {
      if (JSON.stringify(variant.options) == JSON.stringify(options)) {
        currentVariant = variant;
      }
    });

    this.updateMainId(currentVariant);
  }

  updateMainId(currentVariant) {
    this.querySelector('[name="id"]').value = currentVariant.id;

    this.getUpdatedCard(currentVariant);
  }

  getUpdatedCard(currentVariant) {
    this.sectionId = this.dataset.sectionId;
    this.productHandle = this.dataset.productHandle;

    // Include the variant ID in the request URL
    const requestUrl = `/product/${this.productHandle}?variant=${currentVariant.id}&section_id=${this.sectionId}`;

    fetch(requestUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {

        const html = new DOMParser().parseFromString(responseText, "text/html");

      })
      .catch((error) => {
        console.error("Error fetching or processing product details:", error);
      });
  }
}

customElements.define('pair-products', PairProducts);



const variantValueDivs = document.querySelectorAll('.product-card__option--value');

variantValueDivs.forEach(function (div) {
  div.addEventListener('click', function () {
    // Get the variant ID associated with this option
    const variantId = this.querySelector('input[type="radio"]').value;

    // Update the data-variant-ids attribute of the main_product_price_id input
    const mainProductPriceInput = document.querySelector('.main_product_price_id');
    if (mainProductPriceInput) {
      mainProductPriceInput.setAttribute('data-variant-ids', variantId);

      // You can also update the value attribute of the input if needed
      mainProductPriceInput.value = variantId;
    }
  });
});


//////// pair products

document.addEventListener('DOMContentLoaded', function () {
  // Initialize an empty array to store selected variant IDs
  var selectedVariantIds = [];

  // Select all checkbox inputs with the 'variant-checkbox' class
  var checkboxes = document.querySelectorAll('.variant-checkbox');

  // Add a change event listener to each checkbox
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      // Check if the checkbox is checked
      if (checkbox.checked) {
        // Get the value of the hidden input with class 'main_product_price_id'
        var variantId = checkbox.parentElement.querySelector('.main_product_price_id').value;

        // Add the variant ID to the selectedVariantIds array if it's not already there
        if (selectedVariantIds.indexOf(variantId) === -1) {
          selectedVariantIds.push(variantId);
        }
      } else {
        // If the checkbox is unchecked, remove the variant ID from the array
        var variantId = checkbox.parentElement.querySelector('.main_product_price_id').value;
        var index = selectedVariantIds.indexOf(variantId);
        if (index !== -1) {
          selectedVariantIds.splice(index, 1);
        }
      }

      // Now, the selectedVariantIds array contains the IDs of selected variants
      console.log(selectedVariantIds);
    });
  });
});


/// Pair product add to cart button in product page
class AddonButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      let checkboxElement = document.querySelectorAll(".variant-checkbox");
      let formData = {
        "items": [],
        'sections_url': '/cart',
        "sections": ['cart-drawer', 'cart-icon-bubble']
      };
      checkboxElement.forEach((each) => {
        if (each.checked) {
          let parentElement = each.closest('pair-products');
          let data = {
            "id": parentElement.querySelector('.main_product_price_id').value,
            "quantity": 1
          };
          formData.items.push(data);
        }
      });

      if (formData.items.length === 0) return;

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((res) => res.json())
        .then((response) => {
          const cartDrawer = response.sections['cart-drawer'];
          const html = new DOMParser().parseFromString(cartDrawer, 'text/html');
          const cartDrawerElement = document.querySelector('#CartDrawer');
          const cartDrawerActive = document.querySelector('.drawer');
          cartDrawerElement.innerHTML = html.querySelector('#CartDrawer').innerHTML;
          cartDrawerActive.classList.add('active');
          cartDrawerElement.classList.add('active'); // Add the 'active' class

          const cartbubble = response.sections['cart-count-bubble'];

          const bubbleHtml = new DOMParser().parseFromString(cartbubble, 'text/html');
          const cartBubbleElement = document.querySelector('.cart-count-bubble');
          cartBubbleElement.innerHTML = bubbleHtml.querySelector('.cart-count-bubble').innerHTML;


        
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  }
}

customElements.define('addon-button', AddonButton);




const detailsElement = document.querySelector('.VariantPlusQuantity');

detailsElement?.addEventListener('toggle', () => {
  const plusIcon = detailsElement.querySelector('.bundle-plus-icon');
  const minusIcon = detailsElement.querySelector('.bundle-minus-icon');

  if (detailsElement.open) {
    // The <details> tag is open, so hide the plus icon and show the minus icon
    plusIcon.style.display = 'none';
    minusIcon.style.display = 'inline-block';
  } else {
    // The <details> tag is closed, so hide the minus icon and show the plus icon
    minusIcon.style.display = 'none';
    plusIcon.style.display = 'inline-block';
  }
});





////Popup size guid
function togglePopupUpsell() {
  var popup = document.getElementsByClassName("popup_upsell pop_recomendations")[0];
  popup.style.display = "block";
  document.querySelector("body").style.overflow = "hidden";
}

function closeButton() {
  var popup = document.getElementsByClassName("popup_upsell pop_recomendations")[0];
  popup.style.display = "none";
  document.querySelector("body").style.overflow = "scroll";

}
document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.product-card__option').forEach(option => {
  
    option.addEventListener('click', () => {
      console.log("HI ===>");
      const valuesElement = option.querySelector('.product-card__option--values');
      if (valuesElement) {
        valuesElement.classList.toggle('d-none');
      }
    });
  });
});

class LazySection extends HTMLElement {
  static sectionsToFetch = [];

  constructor() {
    super();

    this.section = this.closest('section')?.id || this.closest('[id]').id;
    this.section = this.section?.replace('shopify-section-', '');

    this.trigger = this.dataset.triggerEvent || 'intersection-observer';
    this.targetSelector = this.dataset.triggerTarget || 'body';

    this.boundHandleMouseover = this.handleMouseover.bind(this);
    this.boundHandleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    const targetElement = document.querySelector(this.targetSelector);

    // Different triggers based on data-trigger attribute
    if (this.trigger === 'mouseover') {
      if (screen.width < 990) return;
      
      targetElement.addEventListener('mouseover', this.boundHandleMouseover);
    } else if (this.trigger === 'click') {
      targetElement.addEventListener('click', this.boundHandleClick);
    } else {
      // Default to intersection observer
      new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  // Handler for intersection-observer trigger
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.fetchSections();
  }

  // Handler for mouseover trigger
  handleMouseover() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Handler for click trigger
  handleClick() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Common function for fetching sections
  fetchSections() {
    LazySection.sectionsToFetch.push(this.section);
    const sectionsToFetchBatch = LazySection.sectionsToFetch.length == 5 ? LazySection.sectionsToFetch.splice(0, 5) : LazySection.sectionsToFetch;

      // Check if there is an ongoing network request
    if (LazySection.abortController) {
      LazySection.abortController.abort('Section list updated, cancelling request.');
    }

    LazySection.abortController = sectionsToFetchBatch.length < 5 && new AbortController();

    fetch(window.location.pathname + '?sections=' + sectionsToFetchBatch.join(','), LazySection.abortController.signal ? { signal: LazySection.abortController.signal } : {})
      .then((response) => response.json())
      .then((json) => {
        for (const [key, value] of Object.entries(json)) {
          const sectionContent = new DOMParser().parseFromString(value, 'text/html').getElementById('shopify-section-' + key);

          if (sectionContent && sectionContent.innerHTML.trim().length) {
            const section = document.getElementById('shopify-section-' + key);
            section.innerHTML = sectionContent.innerHTML;
            Defer.dom('.lazy-load-parent img');
            lazyLoadImages()

              // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
            section.querySelectorAll('script').forEach((oldScriptTag) => {
              const newScriptTag = document.createElement('script');
              Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
              });
              newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
              oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
          }
        }

        if (sectionsToFetchBatch.length < 5)
          LazySection.sectionsToFetch = [];
      })
      .catch((e) => {
        console.warn(e);
      });
  }

  // Remove trigger based on data-target attribute
  removeTrigger() {
    const targetElement = document.querySelector(this.targetSelector);

    if (targetElement) {
      targetElement.removeEventListener('mouseover', this.boundHandleMouseover);
      targetElement.removeEventListener('click', this.boundHandleClick);
    }
  }
}

customElements.define('lazy-section', LazySection);

document.querySelectorAll('.link_metafield').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);
    const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - document.querySelector('.main-wrapper-header').offsetHeight;

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth'
    });
  });
});

class CollectionFilterToggle extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init() {
    this.addEventListener("click", this.handleFilterToggle.bind(this));
  }
  handleFilterToggle() {
      const filterSidebar = document.querySelector(".filter-toggle");
      const isFilterSidebarOpen = filterSidebar.getAttribute("data-is-opened") === "true";
      if (isFilterSidebarOpen) {
        this.closeSidebar(filterSidebar);
      } else {
        this.openSidebar(filterSidebar);
      }
  }
  openSidebar(filterSidebar) {
    filterSidebar.setAttribute("data-is-opened", "true");
    filterSidebar.classList.remove("desktop-hide");
    requestAnimationFrame(() => {
      filterSidebar.classList.remove("hide-filters");
      filterSidebar.classList.add("show-filters");
    });
  }
  closeSidebar(filterSidebar) {
    filterSidebar.setAttribute("data-is-opened", "false");
    filterSidebar.classList.add("hide-filters");
    filterSidebar.classList.remove("show-filters");
    filterSidebar.addEventListener("transitionend",() => {
        filterSidebar.classList.add("desktop-hide");
      },{ once: true });
  }
}
if (!window.customElements.get("toggle-filter")) {
  window.customElements.define("toggle-filter", CollectionFilterToggle);
}
